/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BirthdayGiftCreateRequest
 */
export interface BirthdayGiftCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftCreateRequest
     */
    'minPurchaseValue': number;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftCreateRequest
     */
    'trackingPeriod': number;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftCreateRequest
     */
    'expiry': number;
    /**
     * 
     * @type {boolean}
     * @memberof BirthdayGiftCreateRequest
     */
    'isMembership': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BirthdayGiftCreateRequest
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface BirthdayGiftDto
 */
export interface BirthdayGiftDto {
    /**
     * 
     * @type {string}
     * @memberof BirthdayGiftDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof BirthdayGiftDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftDto
     */
    'minPurchaseValue': number;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftDto
     */
    'trackingPeriod': number;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftDto
     */
    'expiry': number;
    /**
     * 
     * @type {boolean}
     * @memberof BirthdayGiftDto
     */
    'isMembership': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BirthdayGiftDto
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface BirthdayGiftResponse
 */
export interface BirthdayGiftResponse {
    /**
     * 
     * @type {BirthdayGiftDto}
     * @memberof BirthdayGiftResponse
     */
    'birthdayGift': BirthdayGiftDto | null;
}
/**
 * 
 * @export
 * @interface BirthdayGiftUpdateRequest
 */
export interface BirthdayGiftUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftUpdateRequest
     */
    'minPurchaseValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftUpdateRequest
     */
    'trackingPeriod': number;
    /**
     * 
     * @type {number}
     * @memberof BirthdayGiftUpdateRequest
     */
    'expiry'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BirthdayGiftUpdateRequest
     */
    'isMembership'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BirthdayGiftUpdateRequest
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateOrderRequest
     */
    'establishment': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequest
     */
    'merchant_reference': string;
    /**
     * 
     * @type {Array<ProductRequest>}
     * @memberof CreateOrderRequest
     */
    'items': Array<ProductRequest>;
    /**
     * 
     * @type {OrderInfoRequest}
     * @memberof CreateOrderRequest
     */
    'orderInfo': OrderInfoRequest;
    /**
     * 
     * @type {PaymentInfoRequest}
     * @memberof CreateOrderRequest
     */
    'paymentInfo': PaymentInfoRequest;
    /**
     * 
     * @type {Array<DiscountRequest>}
     * @memberof CreateOrderRequest
     */
    'discounts'?: Array<DiscountRequest>;
    /**
     * 
     * @type {Array<ServiceFeeRequest>}
     * @memberof CreateOrderRequest
     */
    'serviceFees'?: Array<ServiceFeeRequest>;
}
/**
 * 
 * @export
 * @interface CustomerAddressRequest
 */
export interface CustomerAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressRequest
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressRequest
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressRequest
     */
    'postal_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressRequest
     */
    'line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressRequest
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface CustomerRequest
 */
export interface CustomerRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerRequest
     */
    'email'?: string;
    /**
     * 
     * @type {CustomerAddressRequest}
     * @memberof CustomerRequest
     */
    'address'?: CustomerAddressRequest | null;
}
/**
 * 
 * @export
 * @interface DiscountRequest
 */
export interface DiscountRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountRequest
     */
    'barcode': string;
    /**
     * 
     * @type {number}
     * @memberof DiscountRequest
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface OrderInfoRequest
 */
export interface OrderInfoRequest {
    /**
     * 
     * @type {boolean}
     * @memberof OrderInfoRequest
     */
    'asap': boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderInfoRequest
     */
    'dining_option': number;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'pickup_time'?: string;
    /**
     * 
     * @type {CustomerRequest}
     * @memberof OrderInfoRequest
     */
    'customer'?: CustomerRequest;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'customer_ip': string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'token_name': string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'call_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfoRequest
     */
    'call_name'?: string;
}
/**
 * 
 * @export
 * @interface PaymentInfoRequest
 */
export interface PaymentInfoRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentInfoRequest
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentInfoRequest
     */
    'tip': number;
}
/**
 * 
 * @export
 * @interface ProductModifierRequest
 */
export interface ProductModifierRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductModifierRequest
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductModifierRequest
     */
    'qty': number;
}
/**
 * 
 * @export
 * @interface ProductRequest
 */
export interface ProductRequest {
    /**
     * 
     * @type {number}
     * @memberof ProductRequest
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ProductRequest
     */
    'quantity': number;
    /**
     * 
     * @type {Array<ProductModifierRequest>}
     * @memberof ProductRequest
     */
    'modifieritems'?: Array<ProductModifierRequest>;
}
/**
 * 
 * @export
 * @interface ServiceFeeRequest
 */
export interface ServiceFeeRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceFeeRequest
     */
    'alias': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceFeeRequest
     */
    'amount': number;
}

/**
 * BirthdayGiftApi - axios parameter creator
 * @export
 */
export const BirthdayGiftApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create Birthday Gift
         * @param {string} gamixAppId 
         * @param {BirthdayGiftCreateRequest} birthdayGiftCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        birthdayGiftsControllerCreate: async (gamixAppId: string, birthdayGiftCreateRequest: BirthdayGiftCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('birthdayGiftsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'birthdayGiftCreateRequest' is not null or undefined
            assertParamExists('birthdayGiftsControllerCreate', 'birthdayGiftCreateRequest', birthdayGiftCreateRequest)
            const localVarPath = `/v2/integrations/coop/birthday-gift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(birthdayGiftCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get Birthday Gift
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        birthdayGiftsControllerGetByApp: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('birthdayGiftsControllerGetByApp', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/integrations/coop/birthday-gift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Birthday Gift
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {BirthdayGiftUpdateRequest} birthdayGiftUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        birthdayGiftsControllerUpdate: async (gamixAppId: string, id: string, birthdayGiftUpdateRequest: BirthdayGiftUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('birthdayGiftsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('birthdayGiftsControllerUpdate', 'id', id)
            // verify required parameter 'birthdayGiftUpdateRequest' is not null or undefined
            assertParamExists('birthdayGiftsControllerUpdate', 'birthdayGiftUpdateRequest', birthdayGiftUpdateRequest)
            const localVarPath = `/v2/integrations/coop/birthday-gift/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(birthdayGiftUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BirthdayGiftApi - functional programming interface
 * @export
 */
export const BirthdayGiftApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BirthdayGiftApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create Birthday Gift
         * @param {string} gamixAppId 
         * @param {BirthdayGiftCreateRequest} birthdayGiftCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async birthdayGiftsControllerCreate(gamixAppId: string, birthdayGiftCreateRequest: BirthdayGiftCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BirthdayGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.birthdayGiftsControllerCreate(gamixAppId, birthdayGiftCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BirthdayGiftApi.birthdayGiftsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get Birthday Gift
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async birthdayGiftsControllerGetByApp(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BirthdayGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.birthdayGiftsControllerGetByApp(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BirthdayGiftApi.birthdayGiftsControllerGetByApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Birthday Gift
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {BirthdayGiftUpdateRequest} birthdayGiftUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async birthdayGiftsControllerUpdate(gamixAppId: string, id: string, birthdayGiftUpdateRequest: BirthdayGiftUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BirthdayGiftResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.birthdayGiftsControllerUpdate(gamixAppId, id, birthdayGiftUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BirthdayGiftApi.birthdayGiftsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BirthdayGiftApi - factory interface
 * @export
 */
export const BirthdayGiftApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BirthdayGiftApiFp(configuration)
    return {
        /**
         * 
         * @summary create Birthday Gift
         * @param {string} gamixAppId 
         * @param {BirthdayGiftCreateRequest} birthdayGiftCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        birthdayGiftsControllerCreate(gamixAppId: string, birthdayGiftCreateRequest: BirthdayGiftCreateRequest, options?: any): AxiosPromise<BirthdayGiftResponse> {
            return localVarFp.birthdayGiftsControllerCreate(gamixAppId, birthdayGiftCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get Birthday Gift
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        birthdayGiftsControllerGetByApp(gamixAppId: string, options?: any): AxiosPromise<BirthdayGiftResponse> {
            return localVarFp.birthdayGiftsControllerGetByApp(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Birthday Gift
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {BirthdayGiftUpdateRequest} birthdayGiftUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        birthdayGiftsControllerUpdate(gamixAppId: string, id: string, birthdayGiftUpdateRequest: BirthdayGiftUpdateRequest, options?: any): AxiosPromise<BirthdayGiftResponse> {
            return localVarFp.birthdayGiftsControllerUpdate(gamixAppId, id, birthdayGiftUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BirthdayGiftApi - object-oriented interface
 * @export
 * @class BirthdayGiftApi
 * @extends {BaseAPI}
 */
export class BirthdayGiftApi extends BaseAPI {
    /**
     * 
     * @summary create Birthday Gift
     * @param {string} gamixAppId 
     * @param {BirthdayGiftCreateRequest} birthdayGiftCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BirthdayGiftApi
     */
    public birthdayGiftsControllerCreate(gamixAppId: string, birthdayGiftCreateRequest: BirthdayGiftCreateRequest, options?: RawAxiosRequestConfig) {
        return BirthdayGiftApiFp(this.configuration).birthdayGiftsControllerCreate(gamixAppId, birthdayGiftCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get Birthday Gift
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BirthdayGiftApi
     */
    public birthdayGiftsControllerGetByApp(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return BirthdayGiftApiFp(this.configuration).birthdayGiftsControllerGetByApp(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Birthday Gift
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {BirthdayGiftUpdateRequest} birthdayGiftUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BirthdayGiftApi
     */
    public birthdayGiftsControllerUpdate(gamixAppId: string, id: string, birthdayGiftUpdateRequest: BirthdayGiftUpdateRequest, options?: RawAxiosRequestConfig) {
        return BirthdayGiftApiFp(this.configuration).birthdayGiftsControllerUpdate(gamixAppId, id, birthdayGiftUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.appControllerHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerHealthCheck(options?: any): AxiosPromise<void> {
            return localVarFp.appControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public appControllerHealthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).appControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RevelApi - axios parameter creator
 * @export
 */
export const RevelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirms order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerConfirmOrder: async (createOrderRequest: CreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderRequest' is not null or undefined
            assertParamExists('revelControllerConfirmOrder', 'createOrderRequest', createOrderRequest)
            const localVarPath = `/v2/integrations/revel/orders/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerCreateOrder: async (createOrderRequest: CreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderRequest' is not null or undefined
            assertParamExists('revelControllerCreateOrder', 'createOrderRequest', createOrderRequest)
            const localVarPath = `/v2/integrations/revel/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Modifiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetModifiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/integrations/revel/modifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProductCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/integrations/revel/product-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/integrations/revel/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product Modifier Class
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProductsModifierClass: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/integrations/revel/product-modifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Product Modifier Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProductsModifiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/integrations/revel/product-modifiers/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RevelApi - functional programming interface
 * @export
 */
export const RevelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RevelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Confirms order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerConfirmOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerConfirmOrder(createOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerConfirmOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerCreateOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerCreateOrder(createOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerCreateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Modifiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerGetModifiers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerGetModifiers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerGetModifiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Product Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerGetProductCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerGetProductCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerGetProductCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerGetProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerGetProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerGetProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Product Modifier Class
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerGetProductsModifierClass(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerGetProductsModifierClass(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerGetProductsModifierClass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Product Modifier Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revelControllerGetProductsModifiers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revelControllerGetProductsModifiers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RevelApi.revelControllerGetProductsModifiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RevelApi - factory interface
 * @export
 */
export const RevelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RevelApiFp(configuration)
    return {
        /**
         * 
         * @summary Confirms order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerConfirmOrder(createOrderRequest: CreateOrderRequest, options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerConfirmOrder(createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates order
         * @param {CreateOrderRequest} createOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerCreateOrder(createOrderRequest: CreateOrderRequest, options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerCreateOrder(createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Modifiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetModifiers(options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerGetModifiers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Product Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProductCategories(options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerGetProductCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProducts(options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerGetProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Product Modifier Class
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProductsModifierClass(options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerGetProductsModifierClass(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Product Modifier Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revelControllerGetProductsModifiers(options?: any): AxiosPromise<void> {
            return localVarFp.revelControllerGetProductsModifiers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RevelApi - object-oriented interface
 * @export
 * @class RevelApi
 * @extends {BaseAPI}
 */
export class RevelApi extends BaseAPI {
    /**
     * 
     * @summary Confirms order
     * @param {CreateOrderRequest} createOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerConfirmOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerConfirmOrder(createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates order
     * @param {CreateOrderRequest} createOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerCreateOrder(createOrderRequest: CreateOrderRequest, options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerCreateOrder(createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Modifiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerGetModifiers(options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerGetModifiers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Product Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerGetProductCategories(options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerGetProductCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerGetProducts(options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerGetProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Product Modifier Class
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerGetProductsModifierClass(options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerGetProductsModifierClass(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Product Modifier Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevelApi
     */
    public revelControllerGetProductsModifiers(options?: RawAxiosRequestConfig) {
        return RevelApiFp(this.configuration).revelControllerGetProductsModifiers(options).then((request) => request(this.axios, this.basePath));
    }
}



